import { Box, Card, Typography } from "@mui/material";
import { colors, alphaVar } from "../../../../ui/colors";
import { invoiceEditorSectionCardSx } from "../../../../ui/invoiceEditorSectionSurface";

interface NotesAndTermsInputProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
}

export const NotesAndTermsInput = ({
  value = "",
  onChange,
  placeholder = "Add custom terms or payment instructions...",
}: NotesAndTermsInputProps) => {
  return (
    <Card
      elevation={0}
      sx={{
        ...invoiceEditorSectionCardSx,
        p: 3,
      }}
    >
      <Typography variant="body2" fontWeight={600} sx={{ mb: 2, color: colors.gray[600] }}>
        Notes & Terms
      </Typography>
      <Box
        component="textarea"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        sx={{
          width: "100%",
          minHeight: 100,
          p: 2,
          borderRadius: 2,
          border: `1px solid ${alphaVar(colors.gray[200], 0.5)}`,
          fontSize: "0.875rem",
          fontFamily: "inherit",
          resize: "vertical",
          "&:focus": {
            outline: `2px solid ${alphaVar(colors.orange.base, 0.5)}`,
            outlineOffset: 2,
            borderColor: colors.orange.base,
          },
        }}
      />
    </Card>
  );
};
